import {PrimerSlide} from './PrimerShell';
import {SlideAIllustration} from './PrimerIllustrations';

/** Primer slide A — "Real progress, all in one app."
 *  Phone tracker mockup with the Sleep Debt dial + Rx row. */
export const Glp1PrimerSlideA = () => (
  <PrimerSlide
    letter="A"
    headline="Real progress, all in one app."
    subhead="The full RISE app + your medication + unlimited access to our care team."
    ctaLabel="Next"
  >
    <SlideAIllustration />
  </PrimerSlide>
);

export default Glp1PrimerSlideA;
